export default __webpack_public_path__ + "assets/images/d3c61305e58fe6d8f424ba8adb413a86.png";